/** KAN-931: путь API аккаунтов MAX (общий для клиента API и проверки прав). */
export const MAX_ACCOUNTS_URL = '/api/v1/max-accounts/';
